import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './PageNotFound/page-not-found.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
  declarations: [
    PageNotFoundComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    NzResultModule,
    NzButtonModule,
    NzGridModule,
    NzTypographyModule,
    NzIconModule
  ],
  exports: [],
  providers: [],
})
export class SharedModule { }
